var appLogging = function ($logProvider, __env){
    $logProvider.debugEnabled(__env.enableDebug);
};

appLogging.$inject = ["$logProvider", "__env"];

export default appLogging;
